import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';

type Props = DialogProps & {
  onSaveAndConfirm: () => void;
  loading: boolean;
};
const ConfirmSave = (props: Props) => {
  const {toggle, modalOpen, onSaveAndConfirm, loading} = props;

  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="">
      <DialogTitle id="">Confirmar guardar y avanzar</DialogTitle>
      <DialogContent>
        {loading && <LinearProgress />}
        <DialogContentText>
          Considera que una vez guardas la ronda, avanzaras a una siguiente. Sin
          embargo, te recomendamos revisar los datos una vez más antes de
          continuar
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancel
        </Button>
        <Button onClick={onSaveAndConfirm} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmSave;
